/*!
 * KoliBri - The accessible HTML-Standard
 */
import { e as watchBoolean, y as a11yHintDisabled } from './common-D-vggmh2.js';

const validateDisabled = (component, value) => {
    watchBoolean(component, '_disabled', value, {
        hooks: {
            afterPatch: (value) => {
                if (value === true) {
                    a11yHintDisabled();
                }
            },
        },
    });
};

export { validateDisabled as v };
//# sourceMappingURL=disabled-CL52u2mm.js.map

//# sourceMappingURL=disabled-CL52u2mm.js.map